import requestUtil from '../request-utils.js'

/**
 * 获取子商城信息
 */
function getSubMallInfoList() {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: 'jmall.auth.getsubmallinfolist'
		}, (res => {
			let data = [];
			if (res.code == 200) {
				data = res.result.data || [];
			}
			resolve(data);
		}));
	});
}

/**
 * 获取吉商城订购信息
 */
function getProductOrderInfo() {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: 'jmall.auth.getjmallproductorderinfo'
		}, (res => {
			let data = {};
			if (res.code == 200) {
				data = res.result.data || {};
			}
			resolve(data);
		}));
	});
}

export {
	getSubMallInfoList,
	getProductOrderInfo
}